import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../APIClient/apiClient";
import Toast from "../../component/Toast";
import { resolveImageSrc } from "../../utils/resolveImageSrc";
import "../../style/page/AdminLogin.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState({ message: "", type: "error" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setToast({ message: "", type: "error" });
    setLoading(true);

    try {
      const result = await loginAdmin(username, password);
      localStorage.setItem("adminToken", result.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setToast({ message: err.message, type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: "", type: "error" })} />
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <img src={resolveImageSrc("favicon.ico")} alt="VietQubit logo" className="admin-login-logo" />
          <h1 className="admin-login-title">VietQubit</h1>
          <p className="admin-login-notice">
            This area is restricted to authorized administrators only. If you are not authorized to access this area, please leave immediately.
          </p>
        </div>
        <form onSubmit={handleLogin}>
          <div className="admin-form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              disabled={loading}
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
              required
            />
          </div>

          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
